import React, {useEffect} from 'react';
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {FormattedMessage, injectIntl} from "react-intl";
import $ from "jquery";

import {
  addToCart,
  changeCartFeature,
  toggleSelectionFeatureInfo
} from "../../../actions/actionFunctions";
import {getCurrentLayout} from "../../appLayout";
import {changeQTRoutePath} from "../../../misc/changeRoutePath";
import {subPartIsDone} from "../../selectionWindow/subPartDoneCheckMark";
import {changeSqftFeaturesPopup, setSqftFromFeature} from "../../../actions/sqftFunctions";
import WithCloseSQFtCalc from "../../sqft/hocs/withCloseSQFtCalc";
import WithAddToQuote from "../../sqft/hocs/withAddToQuote";
import {updateQuoteRoomsForCartItems, updateSQFTCreatedStatusForQuotes} from "../../../misc/categorySwitchingFunctions";
import {setQuotes} from "../../../actions/roomsFunctions";
import {SQFT_FEATURES} from "../../sqft/constants";
import {setRelatedGroups} from "../../../actions/selectionFunctions";
import {
  setWizardValuesFromCartItems,
  switchToWizardItem
} from "../../qkbPages/materialsWizard/useChangeWizardStepRoute";
import {showWizardInsteadOfQT} from "../../look/lookNavigation/lookMain/lookWizard/lookWizardFunctions";
import {IS_PRODUCT_JOURNEY} from "../../../config";
import {setWizardConflictPopupOpened, setWizardSqftCartItems} from "../../../actions/wizardFunctions";
import {
  //deleteCartItemsThatAreMissingInSQFTCalcData,
  deleteSQFTCartItems,
  updateActiveQuoteWithSQFTData
} from "../../sqft/helpers/sqftQuotesHelper";
import {isSqftPassedDataEmpty} from "../../sqft/helpers/dataHelper";
import {computeAddedFeatures} from "./utils/computeAddedFeatures";
import {canOpenWizardConflictPopup, handleOpenConflictPopups} from "../../../misc/conflictPopups";
import store from "../../../store";

const SqftFeaturesPopupApplyButton = (props) => {

  const {closePopup, parentsLists, addToCart, qtActiveCategory, activeQuoteIndex, sqftFeaturesPopup,
    changeSqftFeaturesPopup, toggleSelectionFeatureInfo, cartItems, relatedGroups, setRelatedGroups, wizardList,
    wizardIsActive, wizardActiveItem, setWizardSqftCartItems, wizardConflictingSteps, sqftSlabConflicts} = props;

  const {visited, previouslyAddedSqftFeatures} = sqftFeaturesPopup;

  useEffect(() => {
    return () => {
      if (!visited) {
        changeSqftFeaturesPopup({
          visited: true
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // console.log("parentsList", parentsList);

  const skipAddedSteps = () => {
    const layout = getCurrentLayout();
    if (!window.location.href.includes('materials')) {
      return;
    }
    if (showWizardInsteadOfQT(wizardList, wizardIsActive)) {
      switchToWizardItem(wizardActiveItem);
    } else if (layout.qtCategories) {
      const qtCategory = layout.qtCategories.find(qtCategory => qtCategory.name === qtActiveCategory);
      if (!qtCategory) {
        return
      }
      const nextSubPartIndex = qtCategory.subParts.findIndex(subPartItem => {
        return !subPartIsDone(subPartItem.part, activeQuoteIndex, cartItems)
          && subPartItem.part.partId !== SQFT_FEATURES.slabs // skip slabs subpart
      });
      if (Number.isInteger(nextSubPartIndex)) {
        toggleSelectionFeatureInfo(null);
        changeQTRoutePath(qtActiveCategory, nextSubPartIndex);
      }
    }
  }

  const disabled = !parentsLists || parentsLists.some(parentsList => {
    return Object.keys(parentsList).some(parentKey => {
      if (!parentsList[parentKey] || !parentsList[parentKey].features) {
        return false
      }
      const sqftFeatures = parentsList[parentKey].features;
      if (sqftFeatures && sqftFeatures.length) {
        return sqftFeatures.some(sqftFeature => !sqftFeature || !sqftFeature.feature)
      }
      return false
    })
  })

  const applyButtonClick = async (closeSQFtCalc, prepareSQFTData) => {
    if (disabled) {
      const $scrollList = $(".ui-popup__body-content");
      const $scrollToFeature = $(".sqft-popup__feature[data-feature='false']");
      if ($scrollList && $scrollToFeature && $scrollToFeature.offset()) {
        $scrollList.animate({ scrollTop: $scrollToFeature.offset().top }, 800);
      }
      return false;
    }

    const { addedFeatures, cabinetFeatures, previouslySelected } = computeAddedFeatures(
        parentsLists,
        previouslyAddedSqftFeatures,
    );

    changeSqftFeaturesPopup({ previouslyAddedSqftFeatures: previouslySelected });

    const sqftCalcData = await prepareSQFTData();
    if (!isSqftPassedDataEmpty(sqftCalcData)) {
      updateActiveQuoteWithSQFTData(sqftCalcData);
    }
    closePopup();

    await updateQuoteRoomsForCartItems(addedFeatures, false, false);
    await updateSQFTCreatedStatusForQuotes();

    deleteSQFTCartItems();

    if (IS_PRODUCT_JOURNEY && wizardActiveItem) {
      setWizardSqftCartItems(addedFeatures);
      console.log("addedFeatures from sqft", addedFeatures);
    } else {
      addToCart(addedFeatures);
    }
    //deleteCartItemsThatAreMissingInSQFTCalcData();
    addCabinetFeatures(cabinetFeatures);

    if (showWizardInsteadOfQT(wizardList, wizardIsActive)) {
      setWizardValuesFromCartItems(addedFeatures);
    }

    setTimeout(() => {
      skipAddedSteps();
    }, 0);

    closeSQFtCalc();
  };

  const addCabinetFeatures = (cabinetFeatures) => {
    const relatedGroupsWithNewQuantity = relatedGroups.map(relatedGroup => {
      relatedGroup.relatedFeatures.map(relatedFeature => {
        cabinetFeatures.map(cabinetFeature => {
          if (relatedFeature.dbFeature.id === cabinetFeature.feature.dbFeature.id) {
            relatedFeature.cartQuantity = cabinetFeature.quantity
          }
          return relatedFeature
        })

      });
      return relatedGroup
    });

    setRelatedGroups(relatedGroupsWithNewQuantity);
  }

  const hasWizardConflict = wizardConflictingSteps.length && canOpenWizardConflictPopup(store.getState());
  const hasConflict = hasWizardConflict || sqftSlabConflicts.length;

  return (
    <WithAddToQuote props={props}>
      {(handleAddToQuoteClick, prepareSQFTData) => (
        <WithCloseSQFtCalc props={props}>
          {(closeSQFtCalc) => (
            <button className={"ui-button2 ui-button2--secondary"
              + (disabled ? " ui-button2--gray" : "")
              + (hasConflict ? " ui-button2--red" : "")}
                    onClick={() => {
                      if (hasConflict) {
                        handleOpenConflictPopups();
                        return
                      }
                      applyButtonClick(closeSQFtCalc, prepareSQFTData)
                    }}>
              <FormattedMessage id={visited || cartItems.length ? "quotingTool.footer.updateCartButton" : "quotingTool.footer.addToCartButton"}/>
            </button>
          )}
        </WithCloseSQFtCalc>
      )}
    </WithAddToQuote>
  )
};

SqftFeaturesPopupApplyButton.propTypes = {
  parentsLists: PropTypes.array,
}

const mapStateToProps = (store) => {
  const {sqftFeaturesPopup, sqftFromFeature} = store.sqftState;
  const {wizardIsActive, wizardActiveItem, wizardList, wizardConflictingSteps} = store.wizardState;
  const {sqftSlabConflicts} = store.sqftSlabState;
  return {
    sqftFromFeature,
    sqftFeaturesPopup,
    qtActiveCategory: store.qtState.qtActiveCategory,
    quotes: store.quotesState.quotes,
    activeQuoteIndex: store.quotesState.activeQuoteIndex,
    cartItems: store.cartState.cartItems,
    showAdvancedQuoting: store.advancedQuotingState.showAdvancedQuoting,
    relatedGroups: store.selectionState.relatedGroups,
    fabricatorSettings: store.fabricatorState.settings,
    wizardList,
    wizardIsActive,
    wizardActiveItem,
    wizardConflictingSteps,
    sqftSlabConflicts,
  };
};

const mapDispatchToProps = {
  addToCart,
  setQuotes,
  changeSqftFeaturesPopup,
  toggleSelectionFeatureInfo,
  setSqftFromFeature,
  changeCartFeature,
  setRelatedGroups,
  setWizardSqftCartItems,
  setWizardConflictPopupOpened,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(SqftFeaturesPopupApplyButton)
)
